/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HotToastService } from '@ngneat/hot-toast';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { EditorOptions } from 'app/components/text-editor/text-editor.interface';
import { TextEditorService } from 'app/components/text-editor/text-editor.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'edit-bundle-description',
  templateUrl: './edit-bundle-description.component.html',
  styleUrls: ['./edit-bundle-description.component.scss']
})
export class UpdateBundleDescriptionComponent implements OnInit {
  descriptionData: any;
  updateDescriptionForm: FormGroup;
  textEditorOptions: EditorOptions = {
    editorId:'job_desc',
    attachmentType: 'JOB_NOTE',
    placeholder: 'Enter Job Description',
    module:'JOB',
    isForm: true,
    showTemplate: false,
    showTable: false,
  };

  constructor(
    public dialogRef: MatDialogRef<UpdateBundleDescriptionComponent>,
    public utilityService: UtilityService,
    private textEditorService: TextEditorService,
    @Inject(MAT_DIALOG_DATA) public data: any){}


  ngOnInit(): void {
    this.descriptionData = this.data?.data;
    this.textEditorService.focusEditor.next(true);
    this.updateDescriptionForm = new FormGroup({
      job_description: new FormControl(this.descriptionData)
    });
  }

  submit(): void{

    if(this.updateDescriptionForm?.valid){
      this.dialogRef.close(this.updateDescriptionForm?.value?.job_description);
    }

  }

}


